"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBasketValidationData = getBasketValidationData;
exports.basketValidation = basketValidation;
exports.basketHandleBetTypeTabChangeMobileErrors = basketHandleBetTypeTabChangeMobileErrors;
exports.basketHandleBackEndErrors = basketHandleBackEndErrors;
exports.handleBackEndErrors = handleBackEndErrors;
exports.validateBasketInputSaga = validateBasketInputSaga;
const effects_1 = require("redux-saga/effects");
const mapValues_1 = __importDefault(require("lodash/mapValues"));
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const selectors_1 = require("../AccountProvider/selectors");
const basket_1 = require("../../utils/basket");
const selectors_2 = require("../CommonDataProvider/selectors");
const errors_1 = require("../../utils/errors");
const utils_1 = require("./utils");
const saga_1 = require("../ConfigProvider/saga");
const ConfigProvider_1 = require("../ConfigProvider");
const slice_1 = require("./slice");
const selectors_3 = require("./selectors");
const types_1 = require("./types");
const constants_1 = require("./constants");
function* getBasketValidationData() {
    const balance = yield (0, effects_1.select)(selectors_1.selectAccountBalance);
    const bonus = yield (0, effects_1.select)(selectors_1.selectAccountBonus);
    const bonusWallet = yield (0, effects_1.select)(selectors_3.selectBasketBonusWallet);
    const currentBetTypeTab = yield (0, effects_1.select)(selectors_3.selectBasketBetTypeTab);
    const maxBetExpressSystem = yield (0, effects_1.select)(selectors_3.selectMaxBetExpressSystem);
    const ordinarOutcomeErrors = yield (0, effects_1.select)(selectors_3.selectOrdinarOutcomeErrors);
    const minBet = yield (0, effects_1.select)(selectors_2.selectCurrencyMinBet);
    const appliedCoupon = yield (0, effects_1.select)(selectors_3.selectBasketAppliedCoupon);
    const amount = {
        [types_1.EBetTypes.Ordinar]: yield (0, effects_1.select)(selectors_3.selectOrdinarTotalAmount),
        [types_1.EBetTypes.Express]: yield (0, effects_1.select)(selectors_3.selectExpressOutcomeValue),
        [types_1.EBetTypes.System]: yield (0, effects_1.select)(selectors_3.selectSystemAmount),
    }[currentBetTypeTab];
    return {
        availableAmount: bonusWallet ? bonus : balance,
        currentBetTypeTab,
        maxBetExpressSystem,
        amount,
        ordinarOutcomeErrors,
        minBet,
        isBonusWallet: bonusWallet,
        isAppliedCoupon: !!appliedCoupon,
    };
}
// TODO remove with BASKET_VALIDATION_IMPROVEMENTS feature flag
function* basketValidationOrdinar() {
    const { ordinarOutcomeErrors, minBet, amount: amountTotal, // to handle coupon amount
    isAppliedCoupon, } = yield getBasketValidationData();
    const ordinarOutcomeErrorsTotal = [];
    if (amountTotal < minBet && !!amountTotal && !!isAppliedCoupon) {
        ordinarOutcomeErrorsTotal.push(constants_1.EAllBasketErrors.MIN_AMOUNT_MUST_EXCEED);
    }
    const comparedMaxBetAndAmount = (0, mapValues_1.default)(ordinarOutcomeErrors, (error) => {
        const { amount, maxBet } = error;
        const message = amount > maxBet
            ? constants_1.ALL_BASKET_ERROR_MESSAGES[betweb_openapi_axios_1.ErrorCode.BetsPayMaxExceeded]
            : amount < minBet && !!amount
                ? constants_1.ALL_BASKET_ERROR_MESSAGES[constants_1.EAllBasketErrors.MIN_AMOUNT_MUST_EXCEED]
                : undefined;
        return {
            ...error,
            message,
        };
    });
    return { comparedMaxBetAndAmount, ordinarOutcomeErrorsTotal };
}
// TODO remove with BASKET_VALIDATION_IMPROVEMENTS feature flag
function* basketValidationExpressSystem() {
    const { maxBetExpressSystem, amount, minBet } = yield getBasketValidationData();
    const expressSystemErrors = [];
    if (amount > maxBetExpressSystem) {
        expressSystemErrors.push(constants_1.EAllBasketErrors.BETS_PAY_MAX_EXCEEDED);
    }
    else if (amount < minBet && !!amount) {
        expressSystemErrors.push(constants_1.EAllBasketErrors.MIN_AMOUNT_MUST_EXCEED);
    }
    return expressSystemErrors;
}
// TODO remove with BASKET_VALIDATION_IMPROVEMENTS feature flag
function* basketValidation() {
    const errors = [];
    yield (0, effects_1.put)(slice_1.basketProviderActions.removeBasketErrors({
        errors: [
            constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BALANCE,
            constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BONUS,
        ],
    }));
    const { availableAmount, currentBetTypeTab, amount, isBonusWallet, isAppliedCoupon, } = yield getBasketValidationData();
    if (currentBetTypeTab !== types_1.EBetTypes.Ordinar) {
        const expressSystemErrors = yield basketValidationExpressSystem();
        errors.push(...expressSystemErrors);
    }
    else {
        const { comparedMaxBetAndAmount, ordinarOutcomeErrorsTotal } = yield basketValidationOrdinar();
        errors.push(...ordinarOutcomeErrorsTotal);
        yield (0, effects_1.put)(slice_1.basketProviderActions.setOrdinarOutcomeErrors(comparedMaxBetAndAmount));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setOrdinarErrorMessage(comparedMaxBetAndAmount));
    }
    // if appliedCoupon exist, we do ot validate bet amount
    if (amount > availableAmount && !isAppliedCoupon) {
        if (isBonusWallet) {
            errors.push(constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BONUS);
        }
        else {
            errors.push(constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BALANCE);
        }
    }
    const competitorConstraintError = yield (0, effects_1.select)(selectors_3.selectCompetitorConstraintError);
    const competitorsConstraintEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.COMPETITORS_CONSTRAINT_ENABLED);
    if (competitorConstraintError && competitorsConstraintEnabled) {
        errors.push(competitorConstraintError);
    }
    if (errors.length) {
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketErrors({ errors }));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketClientErrors({ errors }));
        return false;
    }
    yield (0, effects_1.put)(slice_1.basketProviderActions.resetBasketErrors());
    return true;
}
function* basketHandleBetTypeTabChangeMobileErrors() {
    const { currentBetTypeTab } = yield getBasketValidationData();
    const outcomesLength = yield (0, effects_1.select)(selectors_3.selectBasketOutcomesLength);
    const errors = [];
    if (currentBetTypeTab === types_1.EBetTypes.Express && outcomesLength < 2) {
        errors.push(constants_1.EAllBasketErrors.EXPRESS_LENGTH);
    }
    else if (currentBetTypeTab === types_1.EBetTypes.System && outcomesLength < 3) {
        errors.push(constants_1.EAllBasketErrors.SYSTEM_LENGTH);
    }
    yield (0, effects_1.put)(slice_1.basketProviderActions.removeBasketErrors({
        errors: [constants_1.EAllBasketErrors.EXPRESS_LENGTH, constants_1.EAllBasketErrors.SYSTEM_LENGTH],
    }));
    yield (0, effects_1.put)(slice_1.basketProviderActions.removeBasketClientErrors({
        errors: [constants_1.EAllBasketErrors.EXPRESS_LENGTH, constants_1.EAllBasketErrors.SYSTEM_LENGTH],
    }));
    if (errors.length) {
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketErrors({ errors }));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketClientErrors({ errors }));
    }
}
function* basketHandleBackEndErrors(errors) {
    var _a;
    const outcomesLength = yield (0, effects_1.select)(selectors_3.selectBasketOutcomesLength);
    const backEndErrors = [];
    if (errors.response.status === 400) {
        const isMakeReRequestBasket = errors.response.data.errors.some(({ code }) => constants_1.ERROR_LIST_WHEN_MAKE_RE_REQUEST_BASKET.includes(code));
        if (isMakeReRequestBasket) {
            // if we have some kind of errors we should get our basket again
            yield (0, effects_1.put)(slice_1.basketProviderActions.getBasket());
        }
        const competitorsConstraintEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.COMPETITORS_CONSTRAINT_ENABLED);
        const errorInfo = (0, errors_1.getErrorOrUnknown)(errors);
        const createErrors = (0, basket_1.getErrorMessage)(errors.response.data.errors);
        if (errorInfo.code === betweb_openapi_axios_1.ErrorCode.ClientBetsBlock) {
            if (((_a = errorInfo.details) === null || _a === void 0 ? void 0 : _a.schema) === 'BetCompetitorConstraintError' &&
                competitorsConstraintEnabled) {
                backEndErrors.push(constants_1.EAllBasketErrors.BET_COMPETITOR_CONSTRAINT_ERROR);
            }
            else {
                backEndErrors.push(...createErrors);
            }
        }
        else {
            backEndErrors.push(...createErrors);
        }
    }
    else if (errors.response.status === 500) {
        const { errors: errorItems } = errors.response.data;
        const groupedByBetCode = (0, groupBy_1.default)(errorItems, 'code');
        if (groupedByBetCode.BET_SYSTEM_ERROR) {
            backEndErrors.push(...(0, basket_1.getErrorMessage)(groupedByBetCode.BET_SYSTEM_ERROR));
        }
        else if ((groupedByBetCode.BET_EVENT_UNDEFINED ||
            groupedByBetCode.BET_SUSPENDED) &&
            outcomesLength === 1) {
            backEndErrors.push(constants_1.EAllBasketErrors.EVENT_CANCELED);
        }
        else if (groupedByBetCode.CHANGED_COEFFICIENT && outcomesLength === 1) {
            // flag saveAny here
            backEndErrors.push(constants_1.EAllBasketErrors.CHANGED_COEFFICIENT);
        }
    }
    if (backEndErrors.length) {
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketErrors({ errors: backEndErrors }));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketClientErrors({ errors: backEndErrors }));
    }
}
function* handleBackEndErrors(error) {
    var _a, _b;
    try {
        const outcomesLength = yield (0, effects_1.select)(selectors_3.selectBasketOutcomesLength);
        const status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
        const errorInfo = (0, errors_1.getErrorOrUnknown)(error);
        const errors = [];
        if (status === 400) {
            const { error: error400, shouldReRequestBasket } = (0, utils_1.get400Error)(errorInfo);
            const competitorsConstraintEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.COMPETITORS_CONSTRAINT_ENABLED);
            if (error400 === betweb_openapi_axios_1.ErrorCode.ClientBetsBlock) {
                if (((_b = errorInfo.details) === null || _b === void 0 ? void 0 : _b.schema) === 'BetCompetitorConstraintError' &&
                    competitorsConstraintEnabled) {
                    errors.push(constants_1.EAllBasketErrors.BET_COMPETITOR_CONSTRAINT_ERROR);
                }
                else {
                    errors.push(error400);
                }
            }
            else {
                errors.push(error400);
            }
            if (shouldReRequestBasket) {
                yield (0, effects_1.put)(slice_1.basketProviderActions.getBasket());
            }
        }
        else if (status === 500) {
            const error500 = (0, utils_1.get500Error)(errorInfo, outcomesLength);
            if (error500) {
                // @ts-ignore
                errors.push(error500);
            }
        }
        if (errors.length > 0) {
            yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketErrors({ errors }));
            yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketClientErrors({ errors }));
        }
        else {
            yield (0, effects_1.put)(slice_1.basketProviderActions.resetBasketErrors());
            yield (0, effects_1.put)(slice_1.basketProviderActions.resetBasketClientErrors());
        }
    }
    catch (error) {
        console.error('Error handling backend errors:', error);
    }
}
function* validateBasketInputSaga() {
    yield (0, effects_1.put)(slice_1.basketProviderActions.removeBasketErrors({
        errors: [
            constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BALANCE,
            constants_1.EAllBasketErrors.BETS_INSUFFICIENT_BONUS,
        ],
    }));
    const errors = [];
    const betType = yield (0, effects_1.select)(selectors_3.selectBasketBetTypeTab);
    if (betType === types_1.EBetTypes.Ordinar) {
        const { outcomesErrors, amountErrors } = yield (0, effects_1.select)(selectors_3.selectOrdinarValidationErrors);
        errors.push(...amountErrors);
        yield (0, effects_1.put)(slice_1.basketProviderActions.setOrdinarOutcomeErrors(outcomesErrors));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setOrdinarErrorMessage(outcomesErrors));
    }
    else {
        const expressSystemErrors = yield (0, effects_1.select)(selectors_3.selectExpressSystemValidationErrors);
        if (expressSystemErrors) {
            errors.push(expressSystemErrors);
        }
    }
    const balanceError = yield (0, effects_1.select)(selectors_3.selectBasketBalanceError);
    const competitorConstraintError = yield (0, effects_1.select)(selectors_3.selectCompetitorConstraintError);
    const competitorsConstraintEnabled = yield (0, effects_1.call)(saga_1.isFeatureFlagEnabledSaga, ConfigProvider_1.EFeatureFlags.COMPETITORS_CONSTRAINT_ENABLED);
    if (competitorConstraintError && competitorsConstraintEnabled) {
        errors.push(competitorConstraintError);
    }
    if (balanceError) {
        errors.push(balanceError);
    }
    if (errors.length > 0) {
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketErrors({ errors }));
        yield (0, effects_1.put)(slice_1.basketProviderActions.setBasketClientErrors({ errors }));
        return;
    }
    yield (0, effects_1.put)(slice_1.basketProviderActions.resetBasketErrors());
    yield (0, effects_1.put)(slice_1.basketProviderActions.resetBasketClientErrors());
}
//# sourceMappingURL=validation.js.map